import config from "config/config";

export async function getSurveyQuestions(surveyGroup) {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  const response = await fetch(
    config.REG_API_BASE_URL + `/Survey?SurveyGroup=${surveyGroup}`,
    options
  );

  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
